// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"5f729e10","182":"9851a3ba","191":"7b2f3dbd","327":"c6202962","440":"452b793b","563":"49f51c0a","668":"8f26d178","770":"fa9bc716","825":"d984312e"}[chunkId] + ".chunk.css";
};